import { createFileRoute } from '@tanstack/react-router';
import { GroupsListPage } from '@/features/settings/groups-list-page.js';

export const Route = createFileRoute('/_app/settings/groups/')({
  component: GroupsListPage,
});
